module.exports = __webpack_public_path__ + "img/DSC_2838.a87505a3.png";